/**
 * Created on 25/8/19.
 */
export default {
    headerRow: ['% of SQ FT', 'Start', 'End',  'Annual Rent', 'PSF', 'Escalation Date', 'Escalation Amount', 'Escalation PSF', 'Options','Option PSF', 'Lease Type'],
    rows: {'no-row': {valueCells: []}}
}